import {
  invalidateTimesheetQueries,
  timesheetKeys,
} from "components/timesheet/queries";

import { useAcknowledgementMutation } from "components/timesheet/acknowledgement/mutation";
import { createDraftTimesheetEntry } from "components/timesheet/draft/api";
import { queryClient } from "utils/react-query";
import { selectUser } from "store";
import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values, user, date) {
  return {
    ...Object.fromEntries(Object.entries(values).filter(([_, v]) => v !== "")),
    employee: user.id,
    date,
  };
}

export function useLogDraftTimesheetEntry() {
  const user = useSelector(selectUser);
  const acknowledgementMutation = useAcknowledgementMutation();

  return useMutation({
    mutationFn: async ({ values }) => {
      const date = values.date;
      const payload = buildPayload(values, user, date);
      const response = await createDraftTimesheetEntry({ item: payload });
      await acknowledgementMutation.mutateAsync(date);

      return { response, date };
    },
    onSuccess: () => {
      toast.success("Draft Entry Created Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.error("Error submitting draft timesheet entry:", error);
    },
  });
}
